import Map from './Map'

export default Map



// WEBPACK FOOTER //
// ./src/components/Map/index.js